import { render, staticRenderFns } from "./info_pcs_20250213.vue?vue&type=template&id=ff81b77c&scoped=true&"
import script from "./info_pcs_20250213.vue?vue&type=script&lang=js&"
export * from "./info_pcs_20250213.vue?vue&type=script&lang=js&"
import style0 from "./info_pcs_20250213.vue?vue&type=style&index=0&id=ff81b77c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff81b77c",
  null
  
)

export default component.exports